import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  dealerDailyCdpSyncSettings: { data: null, loading: false, error: null },
};

const dealerDailyCdpSyncSettingsSlice = createSlice({
  name: 'dealerDailyCdpSyncSettingsComponentState',
  initialState,
  reducers: {
    requestDealerDailyCdpSyncSettings(state, _action: PayloadAction<any>) {
      state.dealerDailyCdpSyncSettings.loading = true;
      state.dealerDailyCdpSyncSettings.error = null;
      state.dealerDailyCdpSyncSettings.data = {
        ...(state.dealerDailyCdpSyncSettings.data || {}),
        body: [],
      };
    },
    requestDealerDailyCdpSyncSettingsSuccess(
      state,
      action: PayloadAction<any>,
    ) {
      state.dealerDailyCdpSyncSettings.data = action.payload;
      state.dealerDailyCdpSyncSettings.loading = false;
    },
    requestDealerDailyCdpSyncSettingsError(state, action: PayloadAction<any>) {
      state.dealerDailyCdpSyncSettings.error = action.payload;
      state.dealerDailyCdpSyncSettings.loading = false;
    },
    requestUpdateDealerDailyCdpSyncSettings(
      state,
      _action: PayloadAction<any>,
    ) {
      state.dealerDailyCdpSyncSettings.loading = true;
      state.dealerDailyCdpSyncSettings.error = null;
    },
    requestUpdateDealerDailyCdpSyncSettingsSuccess(state) {
      state.dealerDailyCdpSyncSettings.loading = false;
    },
    requestUpdateDealerDailyCdpSyncSettingsError(
      state,
      action: PayloadAction<any>,
    ) {
      state.dealerDailyCdpSyncSettings.error = action.payload;
      state.dealerDailyCdpSyncSettings.loading = false;
    },
  },
});

export const {
  actions: dealerDailyCdpSyncSettingsActions,
  reducer,
  name: sliceKey,
} = dealerDailyCdpSyncSettingsSlice;
